import { MediaTypeEnum } from '../../../Common/Basic/enums/media-type.enum';
import { ImageApiModel } from './image.api.model';
import { ContexualKeywordIndicesResponseModel } from './contexual-keyword-indices-response.model';
import { TVEyesArchivedStateEnum } from '../enum/tv-eyes-archived-state.enum';
import { ProminenceScoreApiModel } from '../../monitoring/model/prominence-group-api.model';
import { MentionSocialDataModel } from './mention-social-data.model';
import { MentionInsightApiModel } from './mention-insight-api.model';
import { LicenseSummary } from './mention-license-summery.model';
import { ViMetadata } from './vi-metadata.api.model';

export interface TranslatedMentionModel {
    language?: string;
    headline?: string;
    lead?: string;
    body?: string;
    summary?: string;
};

/** API MODEL */
export class MentionModel {
    accountId: number;
    adValueUsd: number;
    agilityContactId: string;
    agilityOutletId: string;
    attachmentMediaIds: string[];
    attribution: string;
    audienceReach: number;
    body: string;
    bodyKeywords?: string;
    cachedUrl: string;
    canGenerateInsight: boolean;
    cityId: string;
    clipDuration: number;
    contactId: string;
    contactUuid: string;
    contactName: string;
    contactAvatarUrl?: string;
    contexualKeywordIndices: ContexualKeywordIndicesResponseModel[];
    continentId: string;
    countryId: string;
    countyId: string;
    createdByUserId: number;
    createdDate: Date|string|number;
    criticalMentionWordPlayUrl?: string;
    duplicateGroupId: string;
    domainAuthority: number;
    expiryDate: number;
    folderIds: number[];
    geographyDisplayString: string;
    harvestedDate: Date|string|number;
    id?: string;
    images?: ImageApiModel[];
    isAudienceFromSimilarWeb?: boolean;
    isArchivedCriticalMention?: boolean;
    isBroadcastAdvertisement?: boolean;
    isLexisNexis?: boolean;
    isBurrelles?: boolean;
    isCla?: boolean;
    isNla?: boolean;
    isPmgXcago?: boolean;
    isRetweet?: boolean;
    isTweetReply?: boolean;
    isFinancialTimes?: boolean;
    language: string; // 2 character iso code
    lastModifiedByUserId: number;
    lastModifiedDate: Date|string|number;
    matchedKeywords: string[];
    mediaPlayerId: string;
    mediaType: MediaTypeEnum;
    mercuryId: string;
    note: string;
    outletId: string;
    outletName: string;
    outletUuid: string;
    outletAvatarUrl?: string;
    prominenceScores: ProminenceScoreApiModel[];
    providerUrl?: string;
    provinceId: string;
    publishedDate: Date|string|number;
    sentiment: number;
    socialData: MentionSocialDataModel;
    summary: string;
    tagIds: number[];
    thumbnailUrl: string;
    title: string;
    tveyesArchivedState?: TVEyesArchivedStateEnum;
    tvEyesInstaPlayUrl?: string;
    url: string;
    urlRemoved: boolean;
    userId: number;
    viewerUrl: string;
    viewerUrlType: string;
    wordCount: number;
    insights: MentionInsightApiModel[];
    summaryContextualKeywordIndices: ContexualKeywordIndicesResponseModel[];
    translation?: TranslatedMentionModel;
    isTranslatedPreferred?: boolean;
    isEdited?: boolean;
    // mention csv import used only
    cityName?: string;
    stateName?: string;
    countryName?: string;
    originalUrl?: string;
    licenseSummary?: LicenseSummary;
    viMetadata?: ViMetadata;
}

export type PartialMentionApiModel = Partial<MentionModel>;

export interface MentionSaveFailResult {
    mention: MentionModel;
    reason: string;
}
